import { render, staticRenderFns } from "./consignment.vue?vue&type=template&id=00190fa5&"
import script from "./consignment.vue?vue&type=script&lang=js&"
export * from "./consignment.vue?vue&type=script&lang=js&"
import style0 from "./consignment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports